import styled from '@emotion/styled'
import {keyframes} from '@emotion/react'
import {COLORS} from '../constants'

/** Responsive grid laying out the KPI cards (2 columns, 4 from the lg breakpoint). */
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;

  @media (min-width: 960px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
`

/** A single KPI card surface. */
export const KpiCard = styled.div`
  padding: 16px;
  border: 1px solid ${COLORS.border};
  border-radius: 12px;
  background-color: ${COLORS.cardBg};
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
`

/** Top row of a KPI card: label on the left, icon on the right. */
export const KpiCardTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

/** Uppercase caption naming the metric. */
export const KpiLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${COLORS.mutedText};
`

/** Large metric value; its colour is set per card inline. */
export const KpiValue = styled.div`
  margin-top: 8px;
  font-size: 22px;
  font-weight: 700;
`

const shimmer = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.45; }
  100% { opacity: 1; }
`

/**
 * Placeholder card shown while the summary figures are being recomputed for a newly selected view
 * (PT-5717). It reuses {@link KpiCard}'s surface and matches a live card's height, so the real
 * numbers swap in without the page moving under the reader.
 */
export const SkeletonCard = styled(KpiCard)`
  height: 90px;
  animation: ${shimmer} 1.4s ease-in-out infinite;
`
